import React from "react";
import { Link } from "react-router-dom";

const projects = [
  {
    imgSrc: "assets/images/services/Walls/full-house.JPG",
    imgPopup: "assets/images/services/Walls/full-house.JPG",
    title: "Full House Wall Finish",
    description: "Complete exterior wall texturing with modern finish",
    category: "walls",
  },
  {
    imgSrc: "assets/images/services/Steps/steps-lightning.webp",
    imgPopup: "assets/images/services/Steps/steps-lightning.webp",
    title: "Illuminated Stone Steps",
    description: "Outdoor steps with integrated lighting for safety and style",
    category: "walls",
  },
  {
    imgSrc: "assets/images/services/Walls/wall-middle.JPG",
    imgPopup: "assets/images/services/Walls/wall-middle.JPG",
    title: "Modern Wall Design",
    description: "Contemporary texture and design for exterior walls",
    category: "walls",
  },
  {
    imgSrc: "assets/images/services/Walls/steps-walls.webp",
    imgPopup: "assets/images/services/Walls/steps-walls.webp",
    title: "Steps with Textured Wall",
    description: "Combination of staircase and detailed wall finishes",
    category: "walls",
  },
  {
    imgSrc: "assets/images/services/Steps/fit-step-building.jpg",
    imgPopup: "assets/images/services/Steps/step-building.JPG",
    title: "Step Installation",
    description: "Concrete step fitting for residential entrance",
    category: "steps",
  },
  {
    imgSrc: "assets/images/services/Steps/fit-step-and-wall.jpg",
    imgPopup: "assets/images/services/Steps/step-and-wall.JPG",
    title: "Steps and Wall Combo",
    description: "Elegant step layout paired with smooth wall texture",
    category: "steps",
  },
  {
    imgSrc: "assets/images/services/Steps/steps-light.webp",
    imgPopup: "assets/images/services/Steps/steps-light.webp",
    title: "Ambient Garden Steps",
    description: "Soft-lit steps creating a cozy garden walkway",
    category: "steps",
  },
  {
    imgSrc: "assets/images/services/Steps/steps-garden.webp",
    imgPopup: "assets/images/services/Steps/steps-garden.webp",
    title: "Garden Pathway Steps",
    description: "Natural stone steps blending with garden landscape",
    category: "steps",
  },
  {
    imgSrc: "assets/images/services/fireplaces/fit-service-1.png",
    imgPopup: "assets/images/services/fireplaces/fireplace-house.jpg",
    title: "Rustic Outdoor Fireplace",
    description: "Functional and aesthetic outdoor heating solution",
    category: "fireplaces",
  },
  {
    imgSrc: "assets/images/services/fireplaces/fireplace.webp",
    imgPopup: "assets/images/services/fireplaces/fireplace.webp",
    title: "Classic Fireplace Design",
    description: "Traditional fireplace with stone finish",
    category: "fireplaces",
  },
  {
    imgSrc: "assets/images/services/fireplaces/fireplace-lareira.jpg",
    imgPopup: "assets/images/services/fireplaces/fireplace-lareira.jpg",
    title: "Indoor Stone Fireplace",
    description: "Elegant interior fireplace for cozy living spaces",
    category: "fireplaces",
  },
  {
    imgSrc: "assets/images/services/fireplaces/fit-fireplace-rounded-gray.jpg",
    imgPopup: "assets/images/services/fireplaces/fireplace-rounded-gray.JPG",
    title: "Modern Rounded Fireplace",
    description: "Stylish curved fireplace with gray stonework",
    category: "fireplaces",
  },
  {
    imgSrc: "assets/images/services/Patios/patio-pool.JPG",
    imgPopup: "assets/images/services/Patios/patio-pool.JPG",
    title: "Poolside Patio Design",
    description: "Functional patio space next to the pool",
    category: "patios",
  },
  {
    imgSrc: "assets/images/services/Patios/patio-blocks.jpg",
    imgPopup: "assets/images/services/Patios/patio-blocks.jpg",
    title: "Block Pattern Patio",
    description: "Durable patio with artistic block layout",
    category: "patios",
  },
  {
    imgSrc: "assets/images/services/Patios/patio-house.jpg",
    imgPopup: "assets/images/services/Patios/patio-house.jpg",
    title: "Backyard Patio Area",
    description: "Spacious patio with natural elements",
    category: "patios",
  },
  {
    imgSrc: "assets/images/services/Patios/patio-blue-house.JPG",
    imgPopup: "assets/images/services/Patios/patio-blue-house.JPG",
    title: "Blue House Patio",
    description: "Elegant patio setup with matching house theme",
    category: "patios",
  },
  {
    imgSrc: "assets/images/services/Steps/steps-walls.webp",
    imgPopup: "assets/images/services/Steps/steps-walls.webp",
    title: "Main Project: Steps & Walls",
    description: "Highlight of steps integrated with textured walls",
    category: "principal",
  },
  {
    imgSrc: "assets/images/services/Walls/wall-middle.JPG",
    imgPopup: "assets/images/services/Walls/wall-middle.JPG",
    title: "Main Wall Texture",
    description: "Central focus wall with detailed surface design",
    category: "principal",
  },
  {
    imgSrc: "assets/images/services/fireplaces/fireplace.webp",
    imgPopup: "assets/images/services/fireplaces/fireplace.webp",
    title: "Main Fireplace Project",
    description: "Core fireplace design showcasing craftsmanship",
    category: "principal",
  },
  {
    imgSrc: "assets/images/services/Patios/patio-house.jpg",
    imgPopup: "assets/images/services/Patios/patio-house.jpg",
    title: "Main Patio Highlight",
    description: "Signature patio area with elegant flooring",
    category: "principal",
  },
];


export default class ProjectOne extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeFilter: ".principal",
    };
  }

  componentDidMount() {
    const $ = window.$;

    $(window).on("load", () => {
      this.projectMasonaryLayout();
    });

    this.projectMasonaryLayout();
  }

  componentDidUpdate() {
    this.projectMasonaryLayout();
  }

  projectMasonaryLayout() {
    const $ = window.$;

    if ($(".masonary-layout").length) {
      $(".masonary-layout").isotope({
        layoutMode: "masonry",
      });
    }
    if ($(".post-filter").length) {
      $(".post-filter li")
        .children(".filter-text")
        .on("click", (e) => {
          const Self = $(e.currentTarget);
          const selector = Self.parent().attr("data-filter");
          $(".post-filter li").removeClass("active");
          Self.parent().addClass("active");
          $(".filter-layout").isotope({
            filter: selector,
            animationOptions: {
              duration: 500,
              easing: "linear",
              queue: false,
            },
          });
          this.setState({ activeFilter: selector });
          return false;
        });
    }

    if ($(".post-filter.has-dynamic-filters-counter").length) {
      const activeFilterItem = $(
        ".post-filter.has-dynamic-filters-counter"
      ).find("li");
      activeFilterItem.each(function () {
        const filterElement = $(this).data("filter");
        const count = $(".filter-layout").find(filterElement).length;
        $(this).children(".filter-text").find(".count").remove();
      });
    }

    $(".filter-layout").isotope({
      filter: this.state.activeFilter,
      animationOptions: {
        duration: 500,
        easing: "linear",
        queue: false,
      },
    });
  }

  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <section className="project-one-sec">
          <div className="shape1">
            <img
              src={publicUrl + "assets/images/shapes/project-v1-shape1.png"}
              alt=""
            />
          </div>
          <div className="shape2">
            <img
              src={publicUrl + "assets/images/shapes/project-v1-shape2.png"}
              alt=""
            />
          </div>
          <div className="container-fluid">
            <div className="sec-title text-center">
              <div className="sec-title__tagline">
                <span className="left"></span>
                <h6>Our project</h6> <span className="right"></span>
              </div>
              <h2 className="sec-title__title">Our Working Project</h2>
            </div>

            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                {/* Start project One Menu Box */}
                <div className="project-one__menu-box">
                  <ul className="project-filter clearfix post-filter has-dynamic-filters-counter">
                    <li
                      data-filter=".principal"
                      className={
                        this.state.activeFilter === ".principal" ? "active" : ""
                      }
                    >
                      <span className="filter-text">
                        {" "}
                        <i className="icon-hammer"></i> All Project
                      </span>
                    </li>
                    <li
                      data-filter=".walls"
                      className={
                        this.state.activeFilter === ".walls" ? "active" : ""
                      }
                    >
                      <span className="filter-text">
                        {" "}
                        <i className="icon-wrench"></i>Walls
                      </span>
                    </li>
                    <li
                      data-filter=".steps"
                      className={
                        this.state.activeFilter === ".steps" ? "active" : ""
                      }
                    >
                      <span className="filter-text">
                        {" "}
                        <i className="icon-surgery"></i>Steps{" "}
                      </span>
                    </li>
                    <li
                      data-filter=".fireplaces"
                      className={
                        this.state.activeFilter === ".fireplaces"
                          ? "active"
                          : ""
                      }
                    >
                      <span className="filter-text">
                        {" "}
                        <i className="icon-line-chart"></i>Fireplaces
                      </span>
                    </li>
                    <li
                      data-filter=".patios"
                      className={
                        this.state.activeFilter === ".patios" ? "active" : ""
                      }
                    >
                      <span className="filter-text">
                        {" "}
                        <i className="icon-hotel"></i>Patios
                      </span>
                    </li>
                  </ul>
                </div>
                {/* End project Menu Box */}
              </div>
            </div>

            <div className="row filter-layout masonary-layout">
              {/* Start project One Single */}
              {projects.map((project, index) => (
                <div
                  key={index}
                  className={`col-xl-3 col-lg-3 col-md-6 filter-item ${project?.category}`}
                >
                  <div className="project-one__single">
                    <div className="project-one__single-img">
                      <div className="inner">
                        <div
                          style={{
                            backgroundImage: `url(${
                              publicUrl + project.imgSrc
                            })`,
                          }}
                          className="aspect-[9/12] bg-cover bg-center"
                        />
                        <div className="project-one__link">
                          <a
                            className="img-popup"
                            target="_blank"
                            href={publicUrl + project.imgPopup}
                            rel="noreferrer"
                          >
                            <span className="icon-plus-sign"></span>
                          </a>
                        </div>
                      </div>
                      <div className="content-box">
                        <h2>
                          <Link to={`/portfolio`}>{project.title}</Link>
                        </h2>
                        <p>{project.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {/* End project One Single */}
            </div>
          </div>
        </section>
      </>
    );
  }
}
